import { mapGetters, mapActions } from "vuex";
import { getLastCompletedPageFromLS } from "@/utils/util";

export default {
  methods: {
    shouldLastCompletedPageChange(currentPage) {
      if (this.lastCompletedPage) {
        return this.lastCompletedPage < currentPage;
      }
      return true;
    },

    setSequencePage(pageNumber, writeLS = true) {
      if (
        writeLS &&
        this.shouldLastCompletedPageChange(
          this.currentPage,
          "lastCompletedPage"
        )
      ) {
        localStorage.setItem("lastCompletedPage", this.currentPage);
      }

      this.setCurrentSequencePage(pageNumber);
    },

    nextSequencePage() {
      this.setSequencePage(this.currentPage + 1);
    },

    previousSequencePage() {
      this.setSequencePage(this.currentPage - 1);
    },

    ...mapActions("service", ["setCurrentSequencePage"])
  },

  computed: {
    lastCompletedPage() {
      return getLastCompletedPageFromLS();
    },

    ...mapGetters("service", {
      currentPage: "currentSequencePage"
    })
  }
};
